import React, { createContext, useContext, useEffect, useState } from 'react'
import { useRouteMatch, useLocation } from '@fs/zion-router'
import { useQuery } from '@apollo/client'
import api from '../api/brightspot'
import sessionDetailRouteMatches from '../helpers/sessionDetailRoutMatches'
import { getSessionTypeFromURL } from '../helpers/UrlHelper'

export const SessionContext = createContext()

export const useCurrentSession = () => useContext(SessionContext)

export function SessionProvider({ children }) {
  const routeMatch = useRouteMatch(sessionDetailRouteMatches)
  const { search } = useLocation()
  const params = new URLSearchParams(search)
  const previewId = params.get('previewId')
  const pathOrId = previewId || routeMatch?.url
  const [model, setModel] = useState()
  useEffect(() => {
    const sessionType = getSessionTypeFromURL(routeMatch?.url)
    if (sessionType) {
      setModel(sessionType)
    }
  }, [routeMatch])

  const query = useQuery(api.contentSession.contentSessionGQLQuery({ path: pathOrId, model }), {
    // Don't request the data if we don't have a preview id, or a session path
    skip: !model || (!previewId && !routeMatch?.params.id),
  })

  return (
    <SessionContext.Provider
      value={{ sessionData: query?.data?.[model] || query?.previousData?.[model], ...query, setModel, model }}
    >
      {children}
    </SessionContext.Provider>
  )
}
